<template>
  <div class='service-provider-worker-profile-form'>
    <v-form ref="form">
      <v-text-field
        v-model="serviceProviderWorkerProfileDetails.firstName"
        class="left-input"
        :label="$t('registration.client.info.firstname')"
        :placeholder="$t('registration.client.info.firstname.placeholder')"
        dense
        outlined
        required
        autofocus
      />
      <v-text-field
        v-model="serviceProviderWorkerProfileDetails.lastName"
        :label="$t('registration.client.info.lastname')"
        :placeholder="$t('registration.client.info.lastname.placeholder')"
        dense
        outlined
        required
      />
      <vue-tel-input-vuetify
        v-model="serviceProviderWorkerProfileDetails.phone"
        mode="international"
        :placeholder="this.$t('registration.client.info.phonenumber.placeholder')"
        :label="$t('registration.client.info.phonenumber')"
        :selectLabel="$t('registration.client.info.phonenumber.country')"
        outlined
        dense
        required
      />
    </v-form>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'EditServiceProviderWorkerProfileForm',
  computed: {
    ...mapGetters([
      'serviceProviderWorkerProfileDetails',
    ]),
  },
};
</script>

<style lang='scss'>

</style>
